import { UserNameCell } from "@/components";
import { User } from "@/types";
import { formatDate, formatUserRoleToName } from "@/utils";
import { FC } from "react";
import {
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
} from "react-admin";
import { StatusField } from "../status-field";
import { TopToolbar } from "../top-toolbar";

const VettingUsersList: FC = () => {
  return (
    <List<User>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "status", order: "ASC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        rowClick={"show"}
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
      >
        <UserNameCell
          label="Name"
          source="id"
          sortBy="firstName"
          sortable={false}
        />
        <TextField<User> label="Email" source="email" sortable={false} noWrap />
        <FunctionField<User>
          sortable={false}
          label="Role"
          render={({ role }) => formatUserRoleToName(role)}
        />
        <FunctionField<User>
          sortable={true}
          label="Date of Application"
          source="completedOnboardingAt"
          render={({ completedOnboardingAt }) =>
            completedOnboardingAt ? formatDate(completedOnboardingAt) : "—"
          }
        />
        <StatusField label="Status" source="" sortable={false} />
      </Datagrid>
    </List>
  );
};

export { VettingUsersList };
